import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useInvariableMemo } from '../invariable-hooks';
import { QueryParamsHandler } from './query-params-handler';

const parseParams = <T>(search: string): T => {
    const params = new URLSearchParams(search);
    const out = {};

    params.forEach((value, key) => ((out as any)[key] = value));

    return out as T;
};

function useQueryParams<T extends Record<string, string>>(): T;
function useQueryParams<T extends Record<string, any>>(handler: QueryParamsHandler<T>): T;
function useQueryParams<T extends Record<string, any>>(handler?: QueryParamsHandler<T>): T {
    const location = useLocation();
    const search = location.search || '';
    const memoHandler = useInvariableMemo(() => handler);

    return useMemo(() => {
        return memoHandler ? memoHandler.parse(search) : parseParams<T>(search);
    }, [search, memoHandler]);
}

export { useQueryParams };
